import React, { StrictMode } from "react";

// ROOT APP COMPONENT
import App from "./App";

// SITE SETTINGS CONTEXT
import SettingsProvider from "contexts/settingsContext";

// ALL THIRD PARTY LIBRARIES CSS
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "nprogress/nprogress.css";
import "react-quill/dist/quill.snow.css";
import "simplebar-react/dist/simplebar.min.css";
import "pure-react-carousel/dist/react-carousel.es.css";
import ReactDOM from "react-dom/client";
import {
  
  init as initSDK,
} from '@telegram-apps/sdk-react';
import { isTMA } from '@telegram-apps/bridge';

// Polyfill Buffer globally
// import eruda from "eruda";

// eruda.init();


console.log("tma",await isTMA())
if(await isTMA()) {
  console.log("init")
  initSDK({
    launchParams: { tgWebAppVersion:  "7.4"}
  })
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <SettingsProvider>
    <App />
  </SettingsProvider>
  // </React.StrictMode>
);


// // https://github.com/atlassian/react-beautiful-dnd/issues/2407
// root.render(
//  
//     <App />
//   </SettingsProvider>
// );
